<template>
  <div class="grid md:grid-cols-2 gap-2 justify-evenly items-center mb-10">
    <div
      class="flex items-center p-5 rounded-lg border-4 border-apodis text-blue-900 gap-5 text-wrap md:mx-5 xl:mx-10"
    >
      <div class="flex flex-col justify-center items-center">
        <span class="text-3xl font-bold">{{ calculateStatsExcludedRatio }}%</span>
        <span class="text-md">{{ statisticsExcluded.intersection }}</span>
      </div>
      <span class="font-custom text-md">{{ statisticsExcluded.label }}</span>
    </div>
    <div
      class="flex items-center p-5 rounded-lg text-white border-4 border-apodis bg-apodis gap-5 text-wrap md:mx-5 xl:mx-10"
    >
      <div class="flex flex-col justify-center items-center">
        <span class="text-3xl font-bold">{{ calculateStatsIncludedRatio }}%</span>
        <span class="text-md">{{ statisticsIncluded.intersection }}</span>
      </div>
      <span class="font-extrabold text-md">{{ statisticsIncluded.label }}</span>
    </div>
  </div>
</template>
<script lang="ts" setup>
import {computed} from "vue";
import {SupportProgramCategory} from "@/program/interfaces/Program";

const {statisticsIncluded, statisticsExcluded} = defineProps<{
    statisticsIncluded: SupportProgramCategory;
    statisticsExcluded: SupportProgramCategory;
}>();

const calculateStatsExcludedRatio = computed(() => {
    const total = statisticsExcluded.intersection + statisticsIncluded.intersection;

    if (total === 0) {
        return 0;
    }

    return statisticsExcluded.intersection
        ? Math.round(statisticsExcluded.intersection / total * 100).toFixed(0)
        : 0;
});

const calculateStatsIncludedRatio = computed(() => {
    const total = statisticsExcluded.intersection + statisticsIncluded.intersection;

    if (total === 0) {
        return 0;
    }

    return statisticsIncluded.intersection
        ? Math.round(statisticsIncluded.intersection / total * 100).toFixed(0)
        : 0;
});
</script>
